import { Component, OnInit } from "@angular/core";
import { SearchModel } from "../../models/search.model";
import { ActivatedRoute, Router } from "@angular/router";
import { SlideNotifier } from "../../models/slideNotifier.model";
import { NotificationService } from "../../services/notification.service";
import { Announcer } from "../../models/announcer.model";
import { Quote } from "../../models/qoute.model";
import { QueryConfig } from "../../models/queryConfig.model";
import { SlideShowModel } from "../../models/slideshow.model";

declare var require: any

@Component({
    selector: 'search',
    templateUrl: './search.component.html',
    styleUrls: ['../../app.component.css']
})
export class SearchComponent implements OnInit {
    model: SearchModel = new SearchModel();
    query: string;
    keyword: string;
    defaultGif = 'https://i.imgur.com/kd8hLVj.gif';
    nonHackingPattern = new RegExp("^[a-zA-Z0-9_]+$");
    maybeHack: boolean;
    queryConfig: QueryConfig;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private notifier: NotificationService
    ) { }

    ngOnInit(): void {
        this.route.queryParams
            .subscribe(params => {
                this.query = params.q;
                if (!this.query) {
                    this.model.slideNotifier = new SlideNotifier('https://i.imgur.com/gxXK56L.jpg', '', 'Tìm kiếm đi');
                    setTimeout(() => this.notifier.notifySlide(this.model.slideNotifier), 500);
                    this.model.announcer = new Announcer(null, null, 'Tìm ảnh theo từ khóa', 'Nhập vào ô bên dưới', 'Tag như #codau #chure hay tên không dấu');
                    this.model.quote = new Quote('https://i.imgur.com/dWlK7dz.gif', 'https://i.imgur.com/4P2WBUh.jpg', 'Cảm ơn', 'Cảm ơn đã góp mặt vào những ngày vui nớ');
                } else {
                    this.model.announcer = new Announcer(null, null, 'Ảnh của', `${this.query}`, 'Tìm thấy nhiều ảnh');
                    this.model.quote = new Quote('https://i.imgur.com/dWlK7dz.gif', 'https://i.imgur.com/4P2WBUh.jpg', 'Cảm ơn', 'Cảm ơn đã góp mặt vào ngày vui nớ');
                    this.queryConfig = {
                        field: "Id",
                        path: "Pictures",
                        queryField: `Tags.${this.query}`,
                        queryValue: true,
                        limit: 2,
                        reverse: false,
                        prepend: false,
                        opts: null
                    };
                    this.model.slideshow = new SlideShowModel();
                    this.model.slideshow.title = `Hình ảnh của ${this.query}`;
                    this.model.slideshow.description = `Tìm thêm với #lyly`;
                }
            });
    }

    search() {
        if (!this.keyword || this.keyword.length <= 2) {
            return;
        } else {
            this.maybeHack = false;
            this.keyword = this.keyword.startsWith("#")
                ? this.keyword.substr(1)
                : this.keyword;

            if (!this.nonHackingPattern.test(this.keyword)) {
                this.maybeHack = true;
                return;
            }

            this.router.navigate(['/search'], { queryParams: { q: this.keyword } });
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/components/search/search.component.ts